// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"202":"aea24179","506":"7197ed6d","594":"7b667414","720":"4f034e44"}[chunkId] + ".css";
};